import axios from 'axios';
import { put, takeEvery } from 'redux-saga/effects';

import { ProposalType } from '@/controllers/Proposals/types';
import { ActivitiesActionTypes } from '@/store/reducers/activities/action-types';
import { setGlobalError } from '@/store/reducers/global/actions';
import {
  ProposalMetricsActionTypes,
  ProposalMetricsDatesActionTypes,
  ProposalsActionTypes,
} from '@/store/reducers/proposals/action-types';
import { CustomExceptions, ReduxAction } from '@/types';
import { mapPriceConfiguratorV1 } from '@/utils/map-price-configurator-payload';

import { ProposalController } from './ProposalController';

export function* fetchProposal(action: ReduxAction) {
  const { selectedProposalId } = action.sagaPayload;

  try {
    if (selectedProposalId) {
      const { data } = yield ProposalController.fetchProposal(selectedProposalId);

      yield put({
        type: ProposalsActionTypes.FETCH_PROPOSAL.SUCCESS,
        payload: { ...data },
      });
    }
  } catch (error) {
    yield put({ type: ProposalsActionTypes.FETCH_PROPOSAL.FAIL, error });

    if (axios.isAxiosError(error)) {
      if (error?.response?.status === 400) {
        yield put(setGlobalError(new Error(CustomExceptions.PageNotFound)));
      } else {
        console.error(error);
      }
    }
  }
}

export function* savePrice(action: ReduxAction) {
  const { priceConfiguratorMode, proposalId, proposalPriceDetails, infoToFetchActivityData } =
    action.sagaPayload;
  const { activityType, activityId } = infoToFetchActivityData;

  try {
    const pricePayload = mapPriceConfiguratorV1(
      proposalPriceDetails,
      priceConfiguratorMode,
    ) as unknown as ProposalType;

    yield ProposalController.savePrice(proposalId, pricePayload);

    yield put({ type: ProposalsActionTypes.SET_ASSIGMENT_PROGRESS.SUCCESS });

    yield put({
      type: ActivitiesActionTypes.FETCH_ACTIVITY_DETAILS_DATA.START,
      sagaPayload: { activityType, activityId },
    });
  } catch (error) {
    yield put({ type: ProposalsActionTypes.SET_ASSIGMENT_PROGRESS.FAIL, error });

    if (axios.isAxiosError(error)) {
      if (error?.response?.status === 400) {
        yield put(setGlobalError(new Error(CustomExceptions.PageNotFound)));
      } else {
        console.error(error);
      }
    }
  }
}

export function* fetchProposalMetric(action: ReduxAction) {
  const { dateOption } = action.sagaPayload;

  try {
    const { data } = yield ProposalController.fetchProposalMetrics(dateOption);

    yield put({
      type: ProposalMetricsActionTypes.FETCH_PROPOSAL_METRIC.SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({ type: ProposalMetricsActionTypes.FETCH_PROPOSAL_METRIC.FAIL, error });

    if (axios.isAxiosError(error)) {
      if (error?.response?.status === 400) {
        yield put(setGlobalError(new Error(CustomExceptions.PageNotFound)));
      } else {
        console.error(error);
      }
    }
  }
}

export function* fetchProposalMetricsDates(action: ReduxAction) {
  const { dateOption } = action.sagaPayload;

  try {
    const { data } = yield ProposalController.fetchProposalMetricsDates(dateOption);

    yield put({
      type: ProposalMetricsDatesActionTypes.FETCH_PROPOSAL_METRICS_DATES.SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({ type: ProposalMetricsDatesActionTypes.FETCH_PROPOSAL_METRICS_DATES.FAIL, error });

    if (axios.isAxiosError(error)) {
      if (error?.response?.status === 400) {
        yield put(setGlobalError(new Error(CustomExceptions.PageNotFound)));
      } else {
        console.error(error);
      }
    }
  }
}

export function* ProposalControllerSaga() {
  yield takeEvery(ProposalsActionTypes.FETCH_PROPOSAL.START, fetchProposal);
  yield takeEvery(ProposalsActionTypes.SET_ASSIGMENT_PROGRESS.START, savePrice);
  yield takeEvery(ProposalMetricsActionTypes.FETCH_PROPOSAL_METRIC.START, fetchProposalMetric);
  yield takeEvery(
    ProposalMetricsDatesActionTypes.FETCH_PROPOSAL_METRICS_DATES.START,
    fetchProposalMetricsDates,
  );
}
